import React, { useState, useEffect, useRef } from 'react'

/*

*/
const PlaceholderImage = ({
  src,
  height = 160,
  width = 90,
  className = '',
  alt = '',
}) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [isError, setIsError] = useState(false)

  const imgElement = useRef(null)

  useEffect(() => {
    setIsLoaded(false)
    const img = imgElement.current
    if (img && img.complete) {
      setIsLoaded(true)
    }
  }, [src])

  return (
    <>
      {(!isLoaded || isError) && (
        <svg
          viewBox={`0 0 ${width} ${height}`}
          preserveAspectRatio="xMidYMid slice"
        >
          <rect width={width} height={height} fill="#CCC" />
        </svg>
      )}
      {!isError && (
        <img
          ref={imgElement}
          src={src}
          className={className}
          alt={alt}
          style={!isLoaded ? { visibility: 'hidden', height: '1px' } : {}}
          onLoad={() => setIsLoaded(true)}
          onError={() => {
            console.log('image error')
            setIsError(true)
          }}
        />
      )}
    </>
  )
}

export default PlaceholderImage
